import esriId from "@arcgis/core/identity/IdentityManager";
import OAuthInfo from "@arcgis/core/identity/OAuthInfo";
import Portal from "@arcgis/core/portal/Portal";
import {
  resetArcGisUser,
  setArcGisUser,
  setEnterpriseUser,
} from "../redux/action/userReducer-action";
import store from "../redux/store";
import { setAsyncError } from "../utils/helper";
// setDefaultOptions({ css: true });

const signInToEnterprise = async (authInfo) => {
  try {
    const status = await esriId.checkSignInStatus(
      authInfo.portalUrl + "/sharing"
    );

    const portal = new Portal({
      authMode: "immediate",
      url: "https://gis.wfp.org/portal",
    });

    const response = await portal.load();

    store.dispatch(setEnterpriseUser(portal.user));
    return portal.user;
  } catch (err) {
    console.log(err);

    return null;
  }
};

export const createOAuth = async (setError, config, openSnackbar, t) => {
  try {
    const userRole = store.getState()?.userReducer?.userRole ?? "";
    if (userRole !== "editor" && config?.userAccountsEnabled) {
      const enterpriseInfo = new OAuthInfo({
        appId: "IlEGTKHcaimDhLfu",
        portalUrl: "https://gis.wfp.org/portal",
        popup: false,
      });

      esriId.registerOAuthInfos([enterpriseInfo]);
      const user = await signInToEnterprise(enterpriseInfo);
      const fullName = user?.fullName || "";

      const firstName = fullName.split(" ")[0] || "";

      if (user) {
        openSnackbar(
          t("screen.widget.Account.messages.signIn", { 1: firstName })
        );
      }

      return enterpriseInfo;
    } else {
      const info = new OAuthInfo({
        appId: "NUbgskpZPx5um9Wc",
        portalUrl: "https://unwfp.maps.arcgis.com",
        popup: false,
      });

      esriId.registerOAuthInfos([info]);
      esriId
        .checkSignInStatus(info.portalUrl + "/sharing")
        .then(() => {
          const portal = new Portal({
            authMode: "immediate",
            url: "https://unwfp.maps.arcgis.com",
          });

          portal.load().then(() => {
            store.dispatch(setArcGisUser(portal.user));
          });
        })
        .catch((err) => {
          console.warn(err);
          if (!config?.enableEditorSwitch) {
            store.dispatch(resetArcGisUser());
          }
        });
      return info;
    }
  } catch (err) {
    setAsyncError(err, setError);
  }
};
